<template>
    <div class="row left-content" v-if="wallet">
        <div class="col-12">
            <h1>Project wallet {{ wallet.name }}</h1>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="white-block">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="title mb-3">Project Wallet Details</div>
                                <ul class="text-left violation-ul">
                                    <li><b>Account ID: </b>{{ wallet.id }}</li>
                                    <li><b>Account name: </b>{{ wallet.name }}</li>
                                    <li><b>Status: </b>
                                        <b-badge class="mr-1" variant="primary" v-if="wallet.paymentCustomerId">Payment Card Attached</b-badge>
                                        <b-badge variant="success" v-if="wallet.transferCustomerId">Bank Details Attached</b-badge>
                                        <b-badge variant="secondary" v-if="!wallet.paymentCustomerId && !wallet.transferCustomerId">No Payment Data Set</b-badge>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="white-block plr-0">
                    <div class="doted-dd-menu">
                        <b-dropdown class="dropdown dropleft">
                            <div slot="button-content">
                                <i class="fa fa-ellipsis-h"></i>
                            </div>
                        </b-dropdown>
                    </div>
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="title mb-3">Wallet</div>
                                <div class="container">
                                    <ul class="text-left violation-ul">
                                        <li><h4>Balance: <b>{{ wallet.wallet.amount + ' ' + wallet.wallet.currency }}</b></h4></li>
                                        <li v-if="wallet.paymentCustomerId"><b>Payment Customer ID: </b>{{ wallet.paymentCustomerId }}</li>
                                        <li v-if="wallet.transferCustomerId"><b>Transfer Customer ID: </b>{{ wallet.transferCustomerId }}</li>
                                    </ul>
                                    <div class="row">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="white-block">
                    <div class="container">
                        <b-tabs content-class="mt-3" justified lazy>
                            <b-tab title="Income">
                                <incomes :id="id" :walletId="wallet.id" :currency="wallet.wallet.currency"></incomes>
                            </b-tab>
                            <b-tab title="Payments" v-if="wallet.paymentCustomerId">
                                <payments :id="id" :walletId="wallet.id"></payments>
                            </b-tab>
                            <b-tab title="Transfers" v-if="wallet.transferCustomerId">
                                <transfers :id="id" :walletId="wallet.id"></transfers>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Incomes from "@/views/admin/Wallet/Project/Money/Incomes";
import Payments from "@/views/admin/Wallet/Project/Money/Payments";
import Transfers from "@/views/admin/Wallet/Project/Money/Transfers";

export default {
    name: "One",
    props: ['id'],
    data() {
        return {
            wallet: null
        }
    },
    components: {
        'incomes': Incomes,
        'payments': Payments,
        'transfers': Transfers
    },
    mounted() {
        let loader = this.$loading.show();
        window.axios.get('/admin/wallet/wallet-project/' + this.id  + '/view')
            .then(response => {
                    this.wallet = response.data.wallet;
                }
            )
            .finally(() => {
                loader.hide();
            });
    }
}
</script>